import { DynamicBaseForm } from './dynamic-base-form';

export class TextBoxStringForm extends DynamicBaseForm<string> {
    controlType = 'TextBoxStringForm';
  }